import constants from "../constants";
import {getHeaders} from "./global";
import axios from "axios"


function createTestCase(apitest_id, payload){
	return axios.post(
        constants.API_URL + "apitests/" + apitest_id + "/testcases/",
        payload,
        getHeaders()
    )
}

function saveTestCase(apitest_id, testcase_id, payload){
	return axios.patch(
        constants.API_URL + "apitests/" + apitest_id + "/testcases/" + testcase_id + "/",
        payload,
        getHeaders()
    )
}

function getTestCases(apitest_id){
	return axios.get(
        constants.API_URL + "apitests/" + apitest_id + "/testcases/",
        getHeaders()
    )
}

function getTestCase(apitest_id, testcase_id){
	return axios.get(
        constants.API_URL + "apitests/" + apitest_id + "/testcases/" + testcase_id + "/",
        getHeaders()
    )
}

function methodToText(method){
    return constants.METHOD_TO_TEXT[method]
}

function getTestCaseChecks(apitest_id, testcase_id){
	return axios.get(
        constants.API_URL + "apitests/" + apitest_id + "/testcases/" + testcase_id + "/checks/",
        getHeaders()
    )
}

function getTestCaseStatus(apitest_id, testcase_id){
	return axios.get(
        constants.API_URL + "apitests/" + apitest_id + "/testcases/" + testcase_id + "/status/",
        getHeaders()
    )
}

function getCheckTestCase(testcase_id){
    return axios.get(
        constants.API_URL + "checktestcase/?testcase=" + testcase_id,
        getHeaders()
    )
}

function deleteTestCase(apitest_id, testcase_id){
    return axios.delete(
        constants.API_URL + "apitests/" + apitest_id + "/testcases/" + testcase_id + "/",
        getHeaders()
    )
}

export {
    createTestCase,
    getTestCases,
    getTestCase,
    saveTestCase,
    methodToText,
    getTestCaseChecks,
    getTestCaseStatus,
    getCheckTestCase,
    deleteTestCase,
}
